module.exports = __webpack_public_path__ + "img/20200830.3db4b036.png";